"use client";

import { c as _c } from "react/compiler-runtime";
import { useSyncExternalStore } from "react";
import { addWorkingDays, dateParts } from "@/lib/utils/date";
const subscribe = (onStoreChange: () => void) => {
  const id = setInterval(onStoreChange, 60_000);
  return () => clearInterval(id);
};
const getSnapshot = () => new Date().setHours(0, 0, 0, 0);
const getServerSnapshot = () => 0;
export type ProjectedDate = ReturnType<typeof dateParts> & {
  isToday: boolean;
};
export const useProjectedDates = offsets => {
  const $ = _c(3);
  const dayStart = useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
  if (!dayStart) {
    return null;
  }
  let t0;
  if ($[0] !== dayStart || $[1] !== offsets) {
    const today = new Date(dayStart);
    t0 = offsets.map(offset => ({
      ...dateParts(addWorkingDays(today, offset)),
      isToday: offset === 0
    }));
    $[0] = dayStart;
    $[1] = offsets;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
};